/* ==========================================================================
   MyAthanClock — Homepage JS
   Hero floating-card countdown + "Through the day" tab switcher.
   ========================================================================== */

(function(){
  'use strict';

  // ---------- Floating "Next prayer" countdown ----------
  // Demo times — in a real install these would come from the customer's settings.
  // We just want the hero to feel alive on first load.
  const PRAYERS = [
    { name: 'Fajr',    h: 5,  m: 42 },
    { name: 'Dhuhr',   h: 13, m: 8 },
    { name: 'Asr',     h: 16, m: 31 },
    { name: 'Maghrib', h: 19, m: 14 },
    { name: 'Isha',    h: 20, m: 43 }
  ];

  function updateNextPrayer(){
    const now = new Date();
    const currMin = now.getHours() * 60 + now.getMinutes();
    const next = PRAYERS.find(p => (p.h * 60 + p.m) > currMin) || PRAYERS[0];

    let diff = (next.h * 60 + next.m) - currMin;
    if (diff < 0) diff += 24 * 60;
    const hours = Math.floor(diff / 60);
    const mins = diff % 60;
    const timeStr = String(next.h).padStart(2, '0') + ':' + String(next.m).padStart(2, '0');
    const diffStr = `in ${hours}h ${mins}m`;

    // Hero floating card
    document.querySelectorAll('[data-myh-next-label]').forEach(el => {
      el.textContent = 'Next prayer · ' + next.name;
    });
    document.querySelectorAll('[data-myh-next-time]').forEach(el => {
      el.textContent = timeStr;
    });
    document.querySelectorAll('[data-myh-next-diff]').forEach(el => {
      const city = el.dataset.myhCity || 'Toronto';
      el.textContent = `${diffStr} · ${city}`;
    });

    // Companion phone mock (if present)
    document.querySelectorAll('[data-myh-app-time]').forEach(el => {
      el.textContent = timeStr;
    });
    document.querySelectorAll('[data-myh-app-meta]').forEach(el => {
      el.textContent = `${diffStr} to ${next.name}`;
    });
  }

  updateNextPrayer();
  setInterval(updateNextPrayer, 30000);

  // ---------- "Through the day" tabs ----------
  document.querySelectorAll('[data-myh-tab]').forEach(tab => {
    tab.addEventListener('click', () => {
      const id = tab.dataset.myhTab;
      document.querySelectorAll('[data-myh-tab]').forEach(t => {
        t.classList.toggle('active', t === tab);
      });
      document.querySelectorAll('[data-myh-panel]').forEach(p => {
        p.classList.toggle('active', p.dataset.myhPanel === id);
      });
    });
  });

  // ---------- Smooth-scroll for hash anchors (e.g. #how-it-works) ----------
  document.querySelectorAll('a[href^="#"]').forEach(a => {
    a.addEventListener('click', (e) => {
      const href = a.getAttribute('href');
      if (href.length < 2) return;
      const target = document.querySelector(href);
      if (!target) return;
      e.preventDefault();
      target.scrollIntoView({ behavior: 'smooth', block: 'start' });
    });
  });

  // ---------- Scroll-to-top button ----------
  const scrollBtn = document.querySelector('[data-myh-scroll-top]');
  if (scrollBtn){
    const SHOW_AFTER = 600; // pixels scrolled before the button appears
    let ticking = false;
    function updateScrollBtn(){
      if (window.scrollY > SHOW_AFTER){
        scrollBtn.classList.add('visible');
      } else {
        scrollBtn.classList.remove('visible');
      }
      ticking = false;
    }
    window.addEventListener('scroll', () => {
      if (!ticking){
        window.requestAnimationFrame(updateScrollBtn);
        ticking = true;
      }
    }, { passive: true });
    scrollBtn.addEventListener('click', () => {
      window.scrollTo({ top: 0, behavior: 'smooth' });
    });
    updateScrollBtn();
  }

})();